import React from "react";

function LoadingScreen({ message = "Memuat data..." }) {
  return (
    <div className="flex flex-col items-center justify-center p-8 space-y-4">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 rounded-full border-4 border-blue-200 opacity-25"></div>
        <div className="absolute inset-0 rounded-full border-4 border-blue-600 border-t-transparent animate-spin"></div>
      </div>
      <p className="text-gray-600 font-medium text-sm animate-pulse">{message}</p>
    </div>
  );
}

export default LoadingScreen;
